import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AppService } from '../../../../../services';
import { ConfigurationPlanningService } from '../../configuration-planning.service';
import { getSetup } from './grid/get-setup';


@Component({
	selector: 'configuration-planning-trimesters-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './trimesters-view.part.html',
})
export class ConfigurationTrimestersViewPart {

	private readonly util = inject(UtilityService);
	private readonly app = inject(AppService);
	private readonly pageService = inject(ConfigurationPlanningService);
	public setup = getSetup(this.util);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public trimesters = computed(() => this.app.data().trimesters);

}